import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../../../app/i18n";
import { MapPage } from "../../../areas/seller/map/MapPage";
import { parseMapSearch } from "../../../areas/seller/map/searchParams";

/** FE-06 seller map. Filters, text, selection and view are search params (§6.1). */
export const Route = createFileRoute("/app/_seller/map")({
  validateSearch: parseMapSearch,
  beforeLoad: () => loadNamespaces("map", "leads"),
  component: MapPage,
});
